/* eslint-disable no-console */
import {
    currentStatusRequest,
    multiStatusSocketRequest,
} from '../../../common/publish-steps/containers/publish-steps-actions';
import {
    externalRemove,
    getOrderDetailsRequest,
    planningUpdateOrderSocketEvents,
} from './details-actions';

const orderDetailsSockets = [
    {
        eventType: 'EntityUpdated',
        actions: [data => getOrderDetailsRequest({ id: data.entityId, skipLoading: true, triggeredById: data.triggeredById })],
    },
    {
        eventType: 'EntityPublishingTransactionUpdated',
        actions: [data => currentStatusRequest({ id: data.entityId, type: data.entityType })],
    },
    {
        eventType: 'EntityDeleted',
        actions: [() => externalRemove(true)],
    },
    {
        eventType: 'PlanningUpdated',
        actions: [
            data => planningUpdateOrderSocketEvents(data),
        ],
    },
    {
        eventType: 'PlanningDeleted',
        actions: [
            data => planningUpdateOrderSocketEvents({ ...data, isDeleteEvent: true }),
        ],
    },
    {
        eventType: 'PlanningPublishingTransactionUpdated',
        actions: [
            data =>
                multiStatusSocketRequest({ ids: [data.newEntityId || data.entityId] }),
        ],
    },
];

export default orderDetailsSockets;
